<main class="footballer-auth-panel">
  <h1>{{ (sentEmail ? 'footballerAuth.checkEmailTitle' : 'footballerAuth.' + mode + 'Title') | translate }}</h1>
  <p *ngIf="message" role="status">{{ message | translate }}</p>
  <p *ngIf="error" class="text-danger" role="alert">{{ error | translate }}</p>
  <section *ngIf="sentEmail" data-testid="auth-email-sent" [attr.aria-busy]="busy">
    <div class="alert alert-success" role="status">
      <p class="auth-sent-email">{{ sentEmail }}</p>
      <p class="mb-0">{{ 'footballerAuth.checkEmail' | translate }}</p>
    </div>
    <div class="auth-actions">
      <button type="button" class="btn btn-outline-primary" [disabled]="busy" (click)="editEmail()">{{ 'footballerAuth.useAnotherEmail' | translate }}</button>
      <button type="button" class="btn btn-primary" [disabled]="busy || resendSeconds > 0" (click)="submit()">{{ 'footballerAuth.sendAgain' | translate }}<span *ngIf="resendSeconds > 0"> ({{ resendSeconds }} s)</span></button>
    </div>
  </section>
  <a *ngIf="canOpenPasswordInApp" class="btn btn-outline-primary" [href]="passwordAppLink"
    target="_blank" rel="noopener noreferrer">{{ 'publicInvite.appDownload.openInApp' | translate }}</a>
  <section *ngIf="linkAttempt" class="link-confirmation">
    <p>{{ linkConfirmKey | translate }}</p>
    <div class="auth-actions">
      <button type="button" class="btn btn-outline-primary" [disabled]="busy" (click)="cancelLink()">{{ 'common.cancel' | translate }}</button>
      <button type="button" class="btn btn-primary" [disabled]="busy" (click)="confirmLink()">{{ 'footballerAuth.linkAction' | translate }}</button>
    </div>
  </section>
  <section *ngIf="!linkAttempt && !sentEmail && (mode === 'login' || mode === 'register')" class="social-providers">
    <button *ngFor="let provider of providers" type="button" class="btn btn-outline-primary social-provider"
      [disabled]="busy || !availableProviders.includes(provider)" (click)="socialLogin(provider)">
      {{ ('footballerAuth.' + provider) | translate }}
    </button>
    <p *ngIf="mode === 'register'" class="auth-hint">{{ 'footballerAuth.socialSignupHint' | translate }}</p>
    <div class="auth-divider">{{ 'footballerAuth.orEmail' | translate }}</div>
  </section>
  <p *ngIf="!linkAttempt && !sentEmail && (mode === 'register' || mode === 'request')">{{ 'footballerAuth.emailProofHint' | translate }}</p>
  <form *ngIf="!linkAttempt && !sentEmail" (ngSubmit)="submit()" #authForm="ngForm">
    <label *ngIf="mode !== 'password'" for="footballer-email">{{ 'common.email' | translate }}</label>
    <input *ngIf="mode !== 'password'" id="footballer-email" name="email" type="email" autocomplete="username"
      [(ngModel)]="email" required maxlength="254" [disabled]="busy" class="form-control">
    <label *ngIf="mode === 'login' || mode === 'password'" for="footballer-password">{{ 'footballerAuth.password' | translate }}</label>
    <input *ngIf="mode === 'login' || mode === 'password'" id="footballer-password" name="password" type="password"
      [attr.autocomplete]="mode === 'password' ? 'new-password' : 'current-password'"
      [(ngModel)]="password" required maxlength="1024" [disabled]="busy" class="form-control">
    <label *ngIf="mode === 'password'" for="footballer-confirm">{{ 'footballerAuth.confirmPassword' | translate }}</label>
    <input *ngIf="mode === 'password'" id="footballer-confirm" name="confirmation" type="password" autocomplete="new-password"
      [(ngModel)]="confirmation" required maxlength="1024" [disabled]="busy" class="form-control">
    <p *ngIf="mode === 'password'">{{ 'footballerAuth.passwordRule' | translate }}</p>
    <div class="auth-actions">
      <button type="button" class="btn btn-outline-primary" [disabled]="busy" (click)="changeMode('login')"
        *ngIf="mode !== 'login'">{{ 'auth.login' | translate }}</button>
      <button type="submit" class="btn btn-primary" [disabled]="busy || !authForm.valid" [attr.aria-busy]="busy">
        {{ (mode === 'login' ? 'auth.login' : mode === 'password' ? 'common.save' : 'footballerAuth.sendLink') | translate }}
      </button>
    </div>
  </form>
  <div class="auth-links" *ngIf="!linkAttempt && mode === 'login'">
    <button type="button" class="btn btn-link" [disabled]="busy" (click)="changeMode('request')">{{ 'footballerAuth.forgotPassword' | translate }}</button>
    <button type="button" class="btn btn-link" [disabled]="busy" (click)="changeMode('register')">{{ 'footballerAuth.registerTitle' | translate }}</button>
  </div>
</main>
